import Card from 'components/card';
import React, { useState } from 'react';
import { BallTriangle } from 'react-loader-spinner';

const StudentJobOverviewTable = ({ data, isLoading }) => {
  console.log(data, 'data');
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (studentId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [studentId]: !prev[studentId],
    }));
  };

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case 'Selected':
        return 'bg-green-100 text-green-800';
      case 'Not Selected':
        return 'bg-red-100 text-red-800';
      case 'On Hold':
        return 'bg-yellow-100 text-yellow-800';
      case 'Pending':
        return 'bg-blue-100 text-blue-800';
      // Student status colors
      case 'Accepted':
      case 'Going To Attend':
      case 'Will Attend':
        return 'bg-green-100 text-green-800';
      case 'Declined':
      case 'Not Going To Attend':
      case 'Cannot Attend':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <BallTriangle color="#5431ed" />
          <p className="text-sm text-gray-500">Loading student data...</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex h-96 w-full items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50">
        <div className="flex flex-col items-center gap-2 p-4 text-center">
          <div className="rounded-full bg-gray-100 p-3">
            <svg
              className="h-6 w-6 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
          </div>
          <h3 className="text-sm font-medium text-gray-900">
            No students found
          </h3>
          <p className="text-sm text-gray-500">
            There are no students with job assignments yet.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse bg-white dark:bg-navy-800">
        <thead className="bg-gray-50 dark:border-b dark:border-gray-800 dark:bg-navy-900">
          <tr>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white">
              Student Name
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white">
              Contact
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Total Interviews
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Attended
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Selected
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Offers
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {/* {data.map((student) => ( */}
          <React.Fragment key={data.personalInfo.email}>
            <tr className="hover:bg-gray-50 dark:bg-navy-900 hover:dark:bg-navy-900">
              <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">
                {data.personalInfo.name}
              </td>
              <td className="px-4 py-3 text-sm text-navy-800 dark:text-white/60">
                {data.personalInfo.phone}
              </td>
              <td className="px-4 py-3 text-center">
                <div className="flex flex-col items-center">
                  <span className="text-sm font-medium dark:text-white">
                    {data.interviewMetrics.totalInterviews}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-center">
                <div className="flex flex-col items-center">
                  <span className="text-sm font-medium dark:text-white">
                    {data.interviewMetrics.attended}
                  </span>
                  <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                    {(
                      (data.interviewMetrics.attended /
                        data.interviewMetrics.totalInterviews) *
                      100
                    ).toFixed(1)}
                    %
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-center">
                <div className="flex flex-col items-center">
                  <span className="text-sm font-medium dark:text-white">
                    {data.interviewMetrics.selected}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-center">
                <div className="flex flex-col items-center">
                  <span className="text-sm font-medium dark:text-white">
                    {data.offerStatus.totalOffers}
                  </span>
                  <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                    {data.offerStatus.acceptedOffers} Accepted
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 text-center">
                <span
                  className={`rounded-full px-2 py-1 text-xs ${getStatusBadgeColor(
                    data.offerStatus.hasOffer ? 'Selected' : 'Pending'
                  )}`}
                >
                  {data.offerStatus.hasOffer ? 'Placed' : 'In Process'}
                </span>
              </td>
            </tr>
            {/* {expandedRows[data.personalInfo.email] && ( */}
            <tr>
              <td
                colSpan={10}
                className="bg-gray-50 px-4 py-4 dark:bg-navy-900"
              >
                <Card className="dark:border-gray-800">
                  <div className="p-4">
                    <h4 className="mb-4 text-sm font-semibold dark:text-white">
                      Interview History
                    </h4>
                    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                      {/* Interview Statistics */}
                      <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                        <h5 className="mb-2 text-sm font-medium dark:text-white">
                          Overview
                        </h5>
                        <div className="space-y-2 text-sm dark:text-white">
                          <p className="flex justify-between">
                            <span>Total Interviews:</span>
                            <span>{data.interviewMetrics.totalInterviews}</span>
                          </p>
                          <p className="flex justify-between">
                            <span>Attended:</span>
                            <span>{data.interviewMetrics.attended}</span>
                          </p>
                          <p className="flex justify-between">
                            <span>Selected:</span>
                            <span>{data.interviewMetrics.selected}</span>
                          </p>
                          <p className="flex justify-between">
                            <span>Rejected:</span>
                            <span>{data.interviewMetrics.rejected}</span>
                          </p>
                          <p className="flex justify-between">
                            <span>Upcoming:</span>
                            <span>{data.interviewMetrics.upcoming}</span>
                          </p>
                        </div>
                      </div>

                      {/* Interview Details */}
                      <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                        <h5 className="mb-2 text-sm font-medium dark:text-white">
                          Recent Interviews
                        </h5>
                        <div className="space-y-2">
                          {data.interviews.map((interview, index) => (
                            <div
                              key={index}
                              className="flex items-center justify-between border-b border-gray-100 pb-2 text-sm last:border-0 last:pb-0 dark:border-gray-800"
                            >
                              <div className="flex flex-col">
                                {/* <span className="font-medium dark:text-white"> */}

                                {/* </span> */}
                                <span className="font-medium dark:text-white">
                                  {`${index + 1}) ${interview.company || 'N/A'}`}
                                </span>

                                <span className="text-xs text-gray-700 dark:text-gray-400">
                                  {interview.jobTitle || 'N/A'}
                                </span>
                              </div>
                              <div className="flex flex-col items-end gap-1">
                                <span
                                  className={`rounded-full px-2 py-1 text-xs ${getStatusBadgeColor(
                                    interview.overallStatus
                                  )}`}
                                >
                                  HR: {interview.overallStatus || 'Pending'}
                                </span>
                                {(() => {
                                  let responseText = '';
                                  let responseStatus = '';

                                  // Check studentRevert first (for offers)
                                  if (
                                    interview.status &&
                                    interview.status !== 'Pending'
                                  ) {
                                    responseText =
                                      interview.status === 'Accepted'
                                        ? 'Offer Accepted'
                                        : interview.status === 'Declined'
                                        ? 'Offer Declined'
                                        : interview.status;
                                    responseStatus = interview.status;
                                  } else {
                                    // Check latest round status (for attendance)
                                    const rounds = interview.rounds || [];
                                    const latestRound =
                                      rounds.length > 0
                                        ? rounds[rounds.length - 1]
                                        : null;
                                    if (
                                      latestRound &&
                                      latestRound.studentStatus &&
                                      latestRound.studentStatus !== 'Pending'
                                    ) {
                                      responseText =
                                        latestRound.studentStatus ===
                                        'Going To Attend'
                                          ? 'Will Attend'
                                          : latestRound.studentStatus ===
                                            'Not Going To Attend'
                                          ? 'Cannot Attend'
                                          : latestRound.studentStatus;
                                      responseStatus =
                                        latestRound.studentStatus;
                                    }
                                  }

                                  if (responseText) {
                                    return (
                                      <span
                                        className={`rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider shadow-sm ${getStatusBadgeColor(
                                          responseStatus
                                        )}`}
                                      >
                                        Student: {responseText}
                                      </span>
                                    );
                                  }
                                  return null;
                                })()}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </td>
            </tr>
            {/* )} */}
          </React.Fragment>
          {/* ))} */}
        </tbody>
      </table>
    </div>
  );
};

export default StudentJobOverviewTable;
